import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Document.Document_User}
    mutation CreateDocument(
        $title: String!
        $parentId: ID!
        $parentType: EnumDocumentParent!
        $category: EnumDocumentCategory!
        $askedById: ID
        $status: EnumDocumentStatus!
        $statusComment: String
        $fileDescriptor: String
        $userIDs: [ID!]
    ) {
        createDocument(
            input: {
                documentInput: {
                    title: $title
                    parentId: $parentId
                    parentType: $parentType
                    category: $category
                    askedById: $askedById
                    status: $status
                    statusComment: $statusComment
                    fileDescriptor: $fileDescriptor
                }
                userIds: $userIDs
            }
        ) {
            errors
            status
            statusCode
            document {
                ...Document_User
            }
        }
    }
`
